'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GJV = require('geojson-validation');

var isNumericArray = _angular2.default.module('isNumericArray', []).directive('isNumericArray', function ($parse, $compile, GeojsonBuilder) {
  'ngInject';

  return {
    require: 'ngModel',
    link: function link(scope, elem, attrs, ctrl) {

      var active = $parse(elem.attr('is-numeric-array'))(scope);

      if (active) {
        scope.$watch(attrs.ngModel, function (value) {
          if (!_.isNil(value)) {
            var validGeojson = false;
            try {
              var geojsonArray = JSON.parse(value);

              validGeojson = GJV.valid(GeojsonBuilder.getGeojson(geojsonArray));
            } catch (e) {
              console.log('invalid geojson format');
            }
            console.log('geojson validity: ' + validGeojson);
            ctrl.$setValidity('numeric-array', validGeojson);
          }
        });
      }
    }
  };
}).name;

exports.default = isNumericArray;


// WEBPACK FOOTER //
// ./client/app/common/directive/isNumericArray/isNumericArray.js